import { Injectable } from "@angular/core";
import { NgToastService } from "ng-angular-popup";

import { SgrResponse } from 'src/app/core/models/response.model';

@Injectable({
  providedIn: 'root',
})
export class PopupService {

  constructor(private toast: NgToastService) { }

  showSuccess(message: string, options?: { title?: string, duration?: number }) {
    const title = options?.title || 'Sucesso';
    const duration = options?.duration || 5000;
    this.toast.success(message, title, duration);
  }

  showError(message: string, options?: { title?: string, duration?: number }) {
    const title = options?.title || 'Erro';
    const duration = options?.duration || 5000;
    this.toast.danger(message, title, duration);
  }

  showInfo(message: string, options?: { title?: string, duration?: number }) {
    const title = options?.title || 'Atenção';
    const duration = options?.duration || 5000;
    this.toast.info(message, title, duration);
  }

  showAlert(message: string, options?: { title?: string, duration?: number }) {
    const title = options?.title || 'Atenção';
    const duration = options?.duration || 5000;
    this.toast.warning(message, title, duration);
  }
}
